import * as React from "react";
import {cx}       from "emotion";

import "./photo-integration-tile.scss";

import {ComponentLink,
        Link, makeChain} from "@Common/react/cst2";
import {Types}           from "@Common/types";
import {faLink}          from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


export const PhotoIntegrationTile = ({
    id,
    serviceName,
    serviceLogo,
    isPropertyService,
    isRegistered       = false,
    isNew              = false,
    onClick            = null,
}:{
    id                 : Types.Apis.Models.GalleryIntegration['photoServiceId'],
    serviceName        : Types.Apis.Models.GalleryIntegration['serviceName'],
    serviceLogo        : Types.Apis.Models.GalleryIntegration['serviceLogo'],
    isPropertyService ?: Types.Apis.Models.GalleryIntegration['isPropertyService'],
    isRegistered      ?: boolean,
    isNew             ?: boolean,
    onClick           ?: () => void,
}) => (

    makeChain<JSX.Element>()

    .then(() => (
        <div className={cx("photo-integration-tile-6e7 card", {registered: isRegistered}, isPropertyService ? "property-service" : "standard")}
            xd-qa-type="card" xd-qa-name="Photo Integration Option {id}"
            onClick={onClick}
        >
            <img className="thumbnail" src={serviceLogo} />
            <p>
                {isRegistered && (
                    <i className="icon">
                        <FontAwesomeIcon icon={faLink} />
                    </i>
                )}
                {serviceName}
            </p>
            {isNew && (
                <span className="new">New</span>
            )}
        </div>
    ))

    .run()

);